import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { BreadcrumService } from '@app/shared/services/breadcrum.service';
import { PackageSubscriptionService } from '../../services/package-subscription.service';
import { RolesSharedService } from '../../services/roles-shared.service';
import { CheckoutModalComponent } from '../checkout-modal/checkout-modal.component';
declare const $: any;
import * as _ from 'lodash';
import swal from 'sweetalert2';
import {Location} from '@angular/common';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MixpanelEventLoggingService } from '@app/shared/services/mixpanel-event-logging.service';
import { NULL_INJECTOR } from '@angular/core/src/render3/component';
import { environment } from '@env/environment';
import { ChoosepaymentModalComponent } from '@app/shared/components/choosepayment-modal/choosepayment-modal.component';
import { LikeModalServiceService } from '@app/shared/services/like-modal-service.service';
import { NickNameModalService } from '../../services/nick-name-modal.service';
@Component({
  selector: 'app-package-subscription-details',
  templateUrl: './package-subscription-details.component.html',
  styleUrls: ['./package-subscription-details.component.css']
})
export class PackageSubscriptionDetailsComponent implements OnInit {
  @ViewChild(CheckoutModalComponent) checkoutModalDetails: CheckoutModalComponent;
  reportSubscriptionPackageId;
  packageDetails;
  isPurchased: false;
  entityType: string;
  currentView = "summary";
  viewindex: any;
  htmlContent =
  ' <h2><strong class="ql-size-huge">Report Title</strong></h2><p><br></p><p><br></p><p><a href="https://projects.invisionapp.com/" target="_blank">Lorem ipsum </a>dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><h3><strong>Lorem ipsum</strong></h3><p><br></p><p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><h3><strong>Lorem ipsum</strong></h3><p><br></p><p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a, tellus. Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blandit vel, luctus pulvinar, hendrerit id, lorem. Maecenas nec odio et ante tincidunt tempus. Donec vitae sapien ut libero venenatis faucibus. Nullam quis ante. Etiam sit amet orci eget eros faucibus tincidunt. Duis leo. Sed fringilla mauris sit amet nibh. Donec sodales sagittis magna. Sed consequat, leo eget bibendum sodales, augue velit cursus nunc,</p><p><br></p><table><tbody><tr><td data-row="row-5ed5">No</td><td data-row="row-5ed5">Name</td><td data-row="row-5ed5">Age</td><td data-row="row-5ed5">Occupation</td></tr><tr><td data-row="row-ec4a">1</td><td data-row="row-ec4a">ABC</td><td data-row="row-ec4a">30</td><td data-row="row-ec4a">SE</td></tr><tr><td data-row="row-lq7u">2</td><td data-row="row-lq7u">ABC</td><td data-row="row-lq7u">30</td><td data-row="row-lq7u">SE</td></tr><tr><td data-row="row-vt7l">3</td><td data-row="row-vt7l">ABC</td><td data-row="row-vt7l">30</td><td data-row="row-vt7l">SE</td></tr></tbody></table><p><br></p><p><img src="https://ecosystem-uploads.s3.ap-southeast-1.amazonaws.com/7661e062-a7b9-42ea-8137-ac92f48ae61d"></p><p><br></p><ol><li data-list="ordered">A</li><li data-list="ordered">B</li><li data-list="ordered">C</li><li data-list="ordered">D</li></ol><p><br></p><p><br></p>';
load: boolean;
showView: boolean;
userRole;
loggedInStatus;
myRating = 0;
buyToken: number = 1;
totalPrice: number = 250;
tokenPrice: number = 0;
tokenObject: any;
hidePaymentBtn: boolean = false;
stripePublicKey: string;
@BlockUI() blockUI: NgBlockUI;
cartData: any = [];
userId = "";
isActiveID: string;
userDetailsObject;
shareUrl: string;
@ViewChild("paymentMode") choosePayment: ChoosepaymentModalComponent;
  constructor(
    private packageSubscriptionService : PackageSubscriptionService,
    private route: ActivatedRoute,
    private breadcrumService:BreadcrumService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private ngZone: NgZone,
    private rolesSharedService: RolesSharedService,
    private mixpanelEventLoggingService: MixpanelEventLoggingService,
    private location: Location,
    private likeModalService: LikeModalServiceService,
    private nickNameModalService: NickNameModalService,

  ) { }

  ngOnInit() {
    this.reportSubscriptionPackageId = this.route.snapshot.paramMap.get("id");
    this.isLoggedIn();
    this.userDetails();
    this.getSubPackageDetailsById();
    this.entityType = "subscriptionPackage";
    this.stripePublicKey = environment.STRIPE_PUBLIC_KEY;
  }

  getSubPackageDetailsById() {
   this.packageSubscriptionService.getSubPackageDetailsById(this.reportSubscriptionPackageId).subscribe((res: any) => {
     this.packageDetails = res.packageDetails;
     this.packageDetails.contents = this.packageDetails.contents.sort((a, b) => a.indexNum - b.indexNum);
     this.myRating = res.packageDetails.myRatings ? res.packageDetails.myRatings.rating : 0; 
    })
  }

  refreshAPI() {
    this.checkoutModalDetails.hideModal();
    this.getSubPackageDetailsById();
    swal("Success", 'Package purchased successfully', "success");
  }

  switchView() {
  this.currentView = "summary";
    
  } 
  showDetailsView() {
    this.currentView = "details-view";
    this.render();
  }
  render() {
    const html = $.parseHTML(this.htmlContent);
    setTimeout(() => {
      $("#render-area").append(html);
    }, 50);
  }
  
  navRouteToReports() {
    this.router.navigate([`/package-subscription`]);
  }
 
  purchaseModal() {
    this.checkoutModalDetails.showModal(this.entityType, this.reportSubscriptionPackageId);
  }

  viewMessage() {
    $("#messageModal").modal("show");
  }
  closeMessage() {
    $("#messageModal").modal("hide");
  }
  proccedToPurchase() {
    this.purchaseModal();
    setTimeout(() => {
    this.closeMessage();
    }, 50);
  }
  viewReports() {
    $("#reportIndex").modal("show");
   // this.companyDetails.initializeModal();
  }

  hideReports() {
    $("#reportIndex").modal("hide");
  //  console.log('hello from hide');
    if (!this.packageDetails.myRatings) {
      setTimeout(function () {
        $("#ratingModal").modal('show');
      }, 1000);
    }
  }

  closeRatingModal() {
    $("#ratingModal").modal("hide");
  }

  isAccessible(id: string, title: string) {
    this.hideReports();
    this.breadcrumService.setUrl('BC3Label',title);
    if (this.loggedInStatus) {
      if (this.userRole === "tech-analyst") {
        this.router.navigate([`${this.userRole}/reports/report-details/${id}`]);
      } else {
        this.router.navigate([`${this.userRole}/report-details/${id}`]);
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      localStorage.removeItem("REDIRECT_URL");
      localStorage.setItem('REPORT_URL', `/report-details/${id}`)
      this.router.navigate(["/signin"]);
    }
  }

  getHrefUrl(id: string, title: string) {
    if (this.loggedInStatus) {
      if (this.userRole === "tech-analyst") {
        return `/#/${this.userRole}/reports/report-details/${id}`;
      } else {
        return `/#/${this.userRole}/report-details/${id}`;
      }
    } else if (!this.loggedInStatus) {
      // fix reditect login
      return `${document.location.origin}/#/signin`;
    }
  }

  isLoggedIn() {
    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }

  userDetails() {
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      this.userId = this.userDetailsObject.userId;
      console.log('inside user details function:',this.userDetailsObject );
    }

    if (this.authenticationService.isLoggedIn()) {
      this.loggedInStatus = true;
      this.getRole();
    } else {
      this.loggedInStatus = false;
    }
  }

  openLikeModal(data) {
    if(window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null"){
      this.userDetailsObject = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      if (this.loggedInStatus) {
        this.likeModalService.modalStatus(true, data);
      }
    }
  }

  likeClick(postData, index) {
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        console.log(this.userDetailsObject, 'this.userDetailsObject');
        let likeObject;
        likeObject = {
          postId: postData.id,
          postType: "package_subscription",
          userId: this.userId
        };
        this.rolesSharedService.addLike(likeObject).subscribe(likeResponse => {
          if (likeResponse["liked"]) {
            // case when user is liked and updated in server
            postData.liked = true;
            postData.likes += 1;
          } else if (!likeResponse["liked"]) {
            // case when user is not liked and updated in server
            postData.liked = false;
            if (postData.likes != 0) {
              postData.likes -= 1;
            }
          }
        });
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe(
          (response: any) => {
            if (response) {
              this.userDetails();
            }
          }
        );
      }
    } else {
      // fix reditect login
      this.router.navigate(["/signin"]);
    }
  }
  populateComments(data) {
    console.log('data commments:', data);
    data.postType = "package_subscription";
    if (this.loggedInStatus) {
      if (this.userDetailsObject.nickName) {
        data.showComments = !data.showComments;
        this.isActiveID = data.id;
      } else {
        this.nickNameModalService.openNickNameModal();
        this.nickNameModalService.nickNameDataUpdatedObservable.subscribe((response: any) => {
          if (response) {
            this.userDetails();
          }
        });
      }
    } else {
      this.router.navigate(["/signin"]);
    }
  }

  mapPostData(report: any) {
    let data: any = {};
    if (report.myRatings) {
      data = {
        id: report.myRatings.id,
        postId: report.id,
        rating: this.myRating,
        userId: this.userId,
        postType: "package_subscription"
      };
    } else {
      data = {
        postId: report.id,
        rating: this.myRating,
        userId: this.userId,
        postType: "package_subscription"
      };
    }
    return data;
  }

  submitRating(report: any) {
    console.log('from submit function:', report);
    if (report.myRatings) {
      this.rolesSharedService
        .rating(JSON.stringify(this.mapPostData(report)))
        .subscribe((response: any) => {
          if (response) {
            // report.myRatings = true;
            this.closeRatingModal();
            this.getSubPackageDetailsById();
          }
        });
    } else {
      this.rolesSharedService
        .submitRating(JSON.stringify(this.mapPostData(report)))
        .subscribe((response: any) => {
          if (response) {
            // report.myRatings = true;
            this.closeRatingModal();
            this.getSubPackageDetailsById();
          }
        });
    }
  }
  displayShareModal(packageDetails) {
    this.shareUrl = `${document.location.origin}/#/link?type=report&id=${packageDetails.id}`;
    $("#share-modal").modal("show");
  }
  // close share module
  closeShareModal() {
    $("#share-modal").modal("hide");
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/package-subscription-details/package-subscription-details.component.ts